export const alternativeMethodsName = {
  masterpass: "am_masterpass.png",
  applepay: "am_applepay.png",
  payPal: "am_payPal.png",
  visaCheckout: "am_visaCheckout.png",
};
